module.exports = __webpack_public_path__ + "img/Icon - Best Score.8851872e.svg";